var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1259,
    height: 930,
    viewBox: "0 0 1259 930",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M982 527C982 628.068 903.069 710 805.704 710C708.338 710 642.5 628.068 642.5 527C642.5 425.932 708.338 344 805.704 344C903.069 344 982 425.932 982 527Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743 564C743 644.634 677.319 710 596.296 710C515.274 710 510 644.634 510 564C510 483.366 515.274 418 596.296 418C677.319 418 743 483.366 743 564Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751 438C751 518.634 685.319 584 604.296 584C523.274 584 518 518.634 518 438C518 357.366 523.274 292 604.296 292C685.319 292 751 357.366 751 438Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_31_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.5 423.325C509.5 503.959 443.819 569.325 362.796 569.325C281.774 569.325 276.5 503.959 276.5 423.325C276.5 342.692 281.774 277.325 362.796 277.325C443.819 277.325 509.5 342.692 509.5 423.325Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_158",
    x: 366.1,
    y: 67.6,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31_158",
    x: 233.6,
    y: 141.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31_158",
    x: 241.6,
    y: 15.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31_158",
    x: 0.100006,
    y: 0.925201,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.23753678ea52e85f30cce9a040c94c74.svg";
export { ForwardRef as ReactComponent };